import './style.css'

const About = () => {
    return (
        <div className="about">
            <h1>Bio</h1>
            <p>
                My name is Shani, I am a graduate of a bachelor's degree in software engineering
            </p>
            <br />
            <p>
                I have a connection and affinity to the world of the web, High independent learning abilities, high attention to detail.
                I bring with me knowledge and experience in technologies: React.js, Redux, Express, MongoDB, MySQL, Node.js, HTML5, javaScript, ES6, CSS3, Python
                Inside I worked, and continue to work on different projects, and to expand my toolbox with the technologies of Angular, NET and more ...
            </p>
            <br />
            <p>
                Driven by passion, ambition,
                Can say about myself that I have a positive personality, enjoy challenges and problem solving.
                Proud to see results of successful projects.
            </p>
        </div>
    )
}

export default About
